import Keycloak from 'keycloak-js';
import { KEYCLOACK_URL, KEYCLOACK_REALM } from '../config/urls';

const keycloak = new Keycloak({
    url: `${KEYCLOACK_URL}`,
    realm: `${KEYCLOACK_REALM}`,
    clientId: "distvaf-frontend"
});

let isKeycloakInitialized = false; // Track initialization state

export async function initializeKeycloak() {
    if (isKeycloakInitialized) {
        //console.warn('Keycloak is already initialized.');
        return;
    }

    try {
        const authenticated = await keycloak.init();
        isKeycloakInitialized = true; // Mark as initialized

        if (authenticated) {
            sessionStorage.setItem('token', keycloak.token);
            sessionStorage.setItem('token_keycloack', keycloak.token);

            const username = keycloak.tokenParsed?.preferred_username || 'Unknown User';
            sessionStorage.setItem('usuarioLogado', username);
        }
        window.location.href = window.location.origin;
    } catch (error) {
        console.error('Failed to initialize adapter:', error);
        window.location.href = window.location.origin;
    }

    keycloak.login({
        redirectUri: window.location.origin,
        scope: 'openid profile email',
    }).then(async (authenticated) => {
        if (authenticated) {
            console.log('User is authenticated');
            sessionStorage.setItem('token', keycloak.token);
            sessionStorage.setItem('token_keycloack', keycloak.token);

            const username = keycloak.tokenParsed?.preferred_username || 'Unknown User';
            sessionStorage.setItem('usuarioLogado', username);
        }
    }).catch((error) => {
        console.error('Failed to login:', error);
    });
}

export default keycloak;
